<template>
  <b-modal
    id="changePasswordModal"
    :title="$translate('Change password')"
    hide-footer
    size="md"
    centered
    content-class="rounded-8"
    @hide="clear"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.currentPassword" form-group-id="old password" placeholder="Current password" required type="password" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.newPassword" form-group-id="new password" placeholder="New password" required type="password" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 button-wrapper">
        <b-button
          variant="outline-primary"
          size="lg"
          class="btn-delete-device px-50 mt-n2"
          :disabled="!data.currentPassword || !data.newPassword"
          @click="onSubmit"
        >
          {{ 'Save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../components/common/input';
import Notification from '../components/common/notification';
import api from '../api';

export default {
  title: 'Change password',
  components: { Input },
  props: {},
  data() {
    return {
      data: {
        currentPassword: '',
        newPassword: ''
      }
    };
  },
  methods: {
    clear() {
      this.data = {
        currentPassword: '',
        newPassword: ''
      };
    },
    async onSubmit() {
      try {
        await api.auth.resetOwnPassword(this.data);
        this.$root.$emit('bv::hide::modal', 'changePasswordModal');
        Notification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        Notification({ type: 'error', message: this.$translate(err.message) });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
.px-50 {
  padding-left: 50px;
  padding-right: 50px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
